import { connect } from 'react-redux';
import TinyUpload from '../views/tiny/TinyUpload';

function mapStateToProps(state, ownProps) {
  return {
    // 如果需要 Redux state，可以在這裡添加
  };
}

const mapDispatchToProps = (dispatch, ownProps) => ({
  // 如果需要 Redux actions，可以在這裡添加
});

const TinyUploadContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(TinyUpload);

export default TinyUploadContainer;


